import * as MD from '@material-ui/core';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import { ILayoutState } from '../Store/Layout/Types';
import { AppBar } from './AppBar';
import { NotificationBar } from './NotificationBarComponent';
import { Drawer } from './Sidebar/Drawer';
import { TypedStorage } from '../Utils/TypedStorage';
import CloseIcon from '@material-ui/icons/Close';

interface IPropsFromState {
  layout: ILayoutState;
  ui: any;
  updateUI: (name: string, value: any) => void;
}

interface IProps {
  hideAppBarDrawerIcon?: boolean;
}

type AllProps = WithStyles<typeof styles> &
  IPropsFromState &
  RouteComponentProps<{}> &
  IConnectedReduxProps &
  IProps;

const styles = (theme: any) =>
  MD.createStyles({
    container: {
      height: '100vh',
    },
    content: {
      '&.noDrawer': {
        paddingLeft: theme.spacing(1),
      },
      flexGrow: 1,
      paddingRight: theme.spacing(1),
      paddingLeft: theme.Adtrack.dimensions.drawerWidth + theme.spacing(1),
      paddingTop: theme.Adtrack.dimensions.appBarHeight + theme.spacing(1),
      paddingBottom: theme.spacing(1),
      transition: 'padding-left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
      maxHeight: '100vh',
    },
    toolbar: theme.mixins.toolbar,
    listGridContainer: {
      margin: '15px',
    },
    listItemContainer: {
      border: '1px solid #cccccc',
      padding: '5px',
      borderRadius: '5px',
    },
    dialogPaper: {
      minWidth: '400px',
      padding: '10px',
    },
    dialogTitle: {
      paddingBottom: '10px',
      position: 'relative',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

interface IOwnState {
  isDisconnected: boolean;
  openDialog: boolean;
}

export class LayoutComponent extends React.Component<AllProps, IOwnState> {
  public constructor(props: AllProps) {
    super(props);
    this.state = {
      isDisconnected: false,
      openDialog: false,
    };
  }

  public componentDidMount() {
    this.handleConnectionChange();
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);

    // Vérifiez si le message a déjà été affiché
    const messageDisplayed2 = TypedStorage.get('messageDisplayed2', false);
    this.setState({ openDialog: !messageDisplayed2 });
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleConnectionChange);
    window.removeEventListener('offline', this.handleConnectionChange);
  }

  handleConnectionChange = () => {
    const condition = navigator.onLine ? 'online' : 'offline';
    if (condition === 'online') {
      if (this.state.isDisconnected) {
        return this.setState({ isDisconnected: false });
      }
      return;
    }
    if (!this.state.isDisconnected) {
      return this.setState({ isDisconnected: true });
    }
  };

  private showNoticeIfDisconnected = () => {
    if (this.state.isDisconnected) {
      return (
        <div
          style={{
            background: 'red',
            zIndex: 10000,
            position: 'absolute',
            width: '100%',
            textAlign: 'center',
            opacity: '0.5',
          }}
        >
          Pas de réseaux
        </div>
      );
    }
  };

  private handleCloseDialog = () => {
    TypedStorage.set('messageDisplayed2', true);
    this.setState({ openDialog: false });
  };

  private showMessage = () => {
    const { classes } = this.props;

    /*
    if (this.state.openDialog) {
      return (
        <MD.Dialog
          onClose={this.handleCloseDialog}
          maxWidth="sm"
          open={this.state.openDialog}
          classes={{ paper: classes.dialogPaper }}
          style={{ overflow: 'hidden' }}
          aria-labelledby="draggable-dialog-title"
        >
          <MD.DialogTitle className={classes.dialogTitle}>
            Migration en cours
            <MD.IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={this.handleCloseDialog}
            >
              <CloseIcon />
            </MD.IconButton>
          </MD.DialogTitle>
          <MD.DialogContent style={{ padding: '2px 12px' }}>
            En raison d’un changement complet d’API de la part de notre
            partenaire ARPP, une maintenance corrective est en cours.
            <br />
            L’accès à notre service peut être momentanément perturbé.
            <br />
            Nous vous prions de nous excuser pour la gène occasionnée.
          </MD.DialogContent>
        </MD.Dialog>
      );
    }
    */
    return <></>;
  };

  public render(): React.ReactNode {
    const { classes } = this.props;
    return (
      <MD.Grid className={classes.container} id="fffff" container>
        {this.showNoticeIfDisconnected()}
        {this.showMessage()}
        <Route
          component={(props) => (
            <AppBar
              {...props}
              hideDrawerIcon={this.props.hideAppBarDrawerIcon}
            />
          )}
        />
        <Route component={Drawer} />
        <MD.Grid
          container
          className={
            classes.content + (this.props.layout.showDrawer ? '' : ' noDrawer')
          }
          direction="row"
        >
          {this.props.layout.pageContent}
          <NotificationBar />
        </MD.Grid>
      </MD.Grid>
    );
  }
}

const mapStateToProps = ({ layout }: IApplicationState) => ({
  layout,
});

export const Layout =
  connect(mapStateToProps)(
    withStyles(styles)(LayoutComponent),
  );
